import React from 'react';
import Thoughts from './components/Thoughts'

export const App = () => {
 return <Thoughts />
  
}
